export const isSSR = (function () {
  try {
    return !(document !== undefined);
  } catch (e) {
    return true;
  }
})();
